module.exports = __webpack_public_path__ + "static/media/doctor_patientcall-768.d254b245.webp";